var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.113,
    height: 17.112,
    viewBox: "0 0 17.113 17.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.676,9.1A8.557,8.557,0,0,1,3.75,15.781a.828.828,0,0,1-.063-1.229l.389-.389a.83.83,0,0,1,1.1-.069,6.348,6.348,0,1,0-.405-9.6L6.521,6.245a.552.552,0,0,1-.39.943H1.115a.552.552,0,0,1-.552-.552V1.619a.552.552,0,0,1,.943-.391l1.7,1.7A8.557,8.557,0,0,1,17.676,9.1Zm-6.242,2.718.339-.436a.828.828,0,0,0-.145-1.162l-1.4-1.092v-3.6A.828.828,0,0,0,9.395,4.7H8.843a.828.828,0,0,0-.828.828v4.68l2.257,1.755a.828.828,0,0,0,1.162-.145Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryTime);
export default __webpack_public_path__ + "static/media/HistoryTime.6be06e5904394125357ee61717f8e325.svg";
export { ForwardRef as ReactComponent };